var _defs, _path, _line, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_7_2",
    "data-name": "Component 7 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 60,
    height: 60,
    fill: "none",
    stroke: "#1c4983",
    strokeWidth: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M35.747,31.641,23.671,44.193l12.076,11.7",
    transform: "translate(-9.845 -13.766)",
    fill: "none",
    stroke: "#2e70c7",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    x1: 33.388,
    transform: "translate(13.808 30.363)",
    fill: "none",
    stroke: "#2e70c7",
    strokeLinecap: "round",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M30,2.98A27.02,27.02,0,1,1,2.98,30,27.05,27.05,0,0,1,30,2.98M30,0A30,30,0,1,0,60,30,30,30,0,0,0,30,0",
    fill: "#2e70c7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.ef7b6729a578d909c03028440b569ab8.svg";
export { ForwardRef as ReactComponent };